import RemindersModelMC from '../presentation/models/RemindersModelMC';
import { MESSAGE_DETAIL_ACTIONS } from '../constants/actionsConstants';

const getMessageDetail = (id) => (dispatch) => {
  dispatch({ type: MESSAGE_DETAIL_ACTIONS.PROCESS_MESSAGE_REQUEST });
  RemindersModelMC.getMessageDetail({ id })
    .then((data) => {
      dispatch({ type: MESSAGE_DETAIL_ACTIONS.PROCESS_MESSAGE_SUCCESS, payload: data });
      return data;
    })
    .catch((err) => {
      dispatch({ type: MESSAGE_DETAIL_ACTIONS.PROCESS_MESSAGE_FAILURE, payload: err });
      return err;
    });
};

export default getMessageDetail;